import { makeStyles, tokens } from '@fluentui/react-components';
import { ICON_SIZE } from 'src/utils/constants';

export const useChallengeItemStyles = makeStyles({
  fatSideBarAccent: {
    padding: tokens.spacingVerticalNone,
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    borderRadius: tokens.borderRadiusMedium,
  },
  iconContainer: {
    'width': ICON_SIZE,
    'height': ICON_SIZE,
    'position': 'relative',
    'display': 'flex',
    'justifyContent': 'center',
    'alignItems': 'center',
    'margin': tokens.spacingVerticalL,
    '& svg': {
      zIndex: 1,
    },
  },
  backDrop: {
    position: 'absolute',
    inset: tokens.spacingVerticalNone,
    backgroundColor: 'rgb(255, 255, 255)',
    borderRadius: tokens.borderRadiusCircular,
  },
});
